import React, { useState, useEffect } from "react";
import styles from "../assets/templates/FillTheBlank.module.css";
import LessonInstruction from "../containers/instruction/LessonInstruction";
import { useRegisterProgress } from "../hooks/useRegisterProgress";
import { getBrowser, getOS } from "../lib/utils";

import PlayButton from "../components/PlayButton/PlayButton";
import useAudioPlayback from "../hooks/useAudioPlayback";

const FillTheBlank = props => {
  const { blockData, contentIndex, answer, audioUrl, lessonId, totalIndexes } = props;
  const [isAnswered, setIsAnswered] = useState(false);
  const [isCorrect, setIsCorrect] = useState(false)
  const [isChecked, setIsChecked] = useState(false);
  const [userAnswers, setUserAnswers] = useState(Array.isArray(answer) ? Array(answer.length).fill('') : Array(1).fill(''));
  const phrases = typeof blockData.complement.frases === 'string' ? [blockData.complement.frases] : blockData.complement.frases;
  const answers = typeof answer === 'string' ? [answer] : answer;
  const img = blockData.complement.image ? blockData.complement.image.img : null;
  const hasSong = blockData.content[contentIndex].sound ? true : false;
  const hasText = blockData.complement && blockData.complement.texto && blockData.complement.texto.trim() !== '';
  const sourcePath = process.env.REACT_APP_CLOUDFRONT_DNS;

  const { state, togglePlayback } = useAudioPlayback(audioUrl, 'fill_the_blank');

  useEffect(() => {
    setIsAnswered(userAnswers.every((resposta) => resposta.trim() !== ''));
    if (state === 'playing') {
      togglePlayback();
    }

  }, [userAnswers]);

  useEffect(() => {
    tryAgain()
  }, [blockData.block_id]);


  // hook useRegisterProgress
  const { registerProgress } = useRegisterProgress(
    blockData.block_id,
    lessonId,
    blockData.sectionId,
    blockData.section,
    blockData.num,
    totalIndexes,
    "fill_the_blank"
  );

  const handleCompleteClick = async () => {
    try {
      await registerProgress();
    } catch (error) {
      console.log("Erro ao registrar progresso: ", error);
    }
  };

  const handleInputChange = (index, event) => {
    const newAnswers = [...userAnswers];
    newAnswers[index] = event.target.value;
    setUserAnswers(newAnswers);
  };

  const buildAnswer = (index) => {
    if (userAnswers[index] && answers[index] && userAnswers[index].trim() === answers[index].trim()) {
      return (<span key={`correct_${index}`} style={{ color: 'rgb(7, 159, 0)', fontWeight: 'bold' }}>{userAnswers[index].trim()}</span>)
    } else {
      return (
        <React.Fragment key={`answer_${index}`}>
          <span key={`wrong_${index}`} style={{ color: 'rgb(255, 0, 0)', textDecoration: 'line-through', fontWeight: 'bold' }}>
            {userAnswers[index] ? userAnswers[index].trim() : ''}</span>
          {" "}
          <span key={`expected${index}`} style={{ color: 'rgb(0, 54, 120)', fontWeight: 'bold' }}>{answers[index] ? answers[index].trim() : ''}</span>
        </React.Fragment>
      )
    }
  }

  const renderizarParagrafos = () => {
    let inputIndex = 0;
    return phrases.map((item, fraseIndex) => {
      const partes = item.split(/\[(.*?)\]/g);
      return (
        <p style={{ color: '#112B4A', fontWeight: '500', fontSize: '18px' }} key={fraseIndex}>
          {partes.map((parte, i) => {
            if (i % 2 === 0) {
              return parte; // normal text
            } else {
              const currentInputIndex = inputIndex++;
              if (isChecked) {
                return buildAnswer(currentInputIndex)
              } else {
                return (
                  <input
                    key={`input_${fraseIndex}_${i}`}
                    type="text"
                    value={userAnswers[currentInputIndex] || ''}
                    placeholder={"Type here"}
                    className={styles['input-text']}
                    maxLength={"50"}
                    onChange={(e) => handleInputChange(currentInputIndex, e)}
                  />
                );
              }
            }
          })}
        </p>
      );
    });
  };

  const getSong = (sound, sound_mp3) => {

    // Define qual versão do áudio será usada, dependendo do navegador
    let songPlaying = "";
    if (getBrowser() === "Safari" || getOS() === "iOS") {
      songPlaying = `${sourcePath}/media/audios/${sound_mp3}`;
    } else {
      songPlaying = `${sourcePath}/media/audios/${sound}`;
    }

    console.log("🔊 Get audio song:", songPlaying);
    return songPlaying;
  }

  const onPlayClick = (sound) => {

    console.log("🔊 OnPlayClick audio:", sound);
    togglePlayback(sound);
  };

  const actionBtnClick = () => {
    if (isCorrect) {
      handleCompleteClick()
      props.step('skipForward', true)
    } else {
      tryAgain()
    }
  }

  function tryAgain() {
    setIsChecked(false);
    setIsAnswered(false);
    setIsCorrect(false);
    const userAns = Array.isArray(answer) ? Array(answer.length).fill('') : Array(1).fill('')
    setUserAnswers(userAns)
  }

  function check() {
    setIsChecked(true);
    const trimmedAnswers = answers.map(answer => answer.trim());
    const trimmedUserAnswers = userAnswers.map(userAnswer => userAnswer.trim());
    setIsCorrect(JSON.stringify(trimmedAnswers) === JSON.stringify(trimmedUserAnswers));
  }

  const buttonCheck = () => {
    return <>
      {
        isChecked &&
        <button className={styles['btn-check']} onClick={() => actionBtnClick()}>
          {isCorrect ? "Continue" : "Try Again"}
        </button>
      }
      {
        !isChecked &&
        <button disabled={!isAnswered} className={styles['btn-check']} onClick={() => check()}>
          Check Answer
        </button>
      }
    </>
  }

  const renderMedia = () => {
    return <>
      {img &&
        <div style={{ display: 'flex', justifyContent: 'center', height: '280px', marginBottom: '1rem' }}>
          <div style={{ borderRadius: '.5rem', overflow: 'hidden', backgroundColor: 'green' }}>
            <img alt="Phrase" style={{ objectFit: "cover" }} src={`${process.env.REACT_APP_CLOUDFRONT_DNS}/media/images/` + blockData.complement.image.img} />
          </div>
        </div>
      }

      {!img && hasText &&
        <div className={styles['text-container']}>
          <label>{blockData.complement.texto} </label>
        </div>
      }

      {!img && !hasText && hasSong &&
        <div
          className={styles['song-container']}
        >
          <PlayButton isPlaying={state==='playing'} onClick={() => {
            let song = getSong(blockData.content[contentIndex].sound, blockData.content[contentIndex].sound_mp3);
            onPlayClick(song);
          }} />
        </div>
      }
    </>
  }

  const renderInstruction = () => {
    return (
      <>
        <LessonInstruction
          instructionText={blockData.content[contentIndex].instruction}
          audioUrl={audioUrl}
        />
      </>
    )
  }

  const renderContent = () => {
    return (
      <div style={{ width: '100%' }}>
        <div className={styles['media-container col-md-12 pl-0']}>
          {renderMedia()}
        </div>
        <div className={styles['column']}>
          <div style={{ justifyContent: 'center', backgroundColor: 'white', display: 'flex', alignItems: 'center' }}>
            <div className={styles['phrases-container']}>
              {renderizarParagrafos()}
            </div>
          </div>
          {buttonCheck()}
        </div>
      </div>
    )
  }

  return (
    <div className="default-card container new-bg-color">
      {blockData.content[contentIndex].type === "instruction" ? renderInstruction() : renderContent()}
    </div>
  );
};
export default FillTheBlank;
